const transactionsI18n = {
  "fr": {
    "transactions": {
      "title": "Transactions",
      "loading": "Chargement…",
      "empty": "Aucune transaction.",
      "labels": {
        "pcs": "pcs",
        "tracking": "Suivi:",
        "received": "Reçues"
      },
      "search": {
        "placeholder": "Recherche: id (8), email, réf…"
      },
      "filters": {
        "all": "Tous",
        "ongoing": "En cours",
        "completed": "Terminées",
        "waybill": "Bordereau",
        "reception": "Réception",
        "control": "Contrôle",
        "pdf": "PDF",
        "paid": "Payé"
      },
      "steps": {
        "title": "Étapes",
        "waybill": "Bordereau",
        "reception": "Réception",
        "control": "Contrôle",
        "pdf": "PDF",
        "paid": "Payé"
      },
      "actions": {
        "title": "Actions",
        "refresh": "Rafraîchir",
        "control": "Contrôle",
        "upload": "Upload",
        "uploading": "Upload…",
        "waybill": "Bordereau",
        "tracking": "Suivi",
        "pdf": "PDF",
        "detail": "Détail",
        "iban": "IBAN",
        "uploadTooltip": "Uploader (PDF)",
        "ibanTooltip": "Voir IBAN (masqué) / Révéler pour paiement",
        "sendEmail": "Envoyer un e-mail",
        "sendWaybillEmail": "Envoyer bordereau",
        "sendRecapEmail": "Envoyer récap",
        "copyEmail": "Copier e-mail"
      },
      "pdf": {
        "verif": {
          "title": "Aperçu — PDF de contrôle",
          "loading": "Chargement du PDF…",
          "error": "PDF introuvable.",
          "empty": "PDF indisponible."
        },
        "waybill": {
          "title": "Aperçu — Bordereau",
          "loading": "Chargement du bordereau…",
          "error": "Bordereau introuvable.",
          "empty": "Pas de bordereau."
        }
      },
      "setup": {
        "title": "Bordereau mis en ligne — Saisir le numéro de colis",
        "refTitle": "Référence colis",
        "help": "Renseignez le numéro de suivi (Colissimo, Chronopost, etc.). Il sera visible dans le récap et chez le client.",
        "inputLabel": "Numéro de colis",
        "inputPlaceholder": "ex. 6A12345678901",
        "alert": "Le bordereau est bien stocké. Enregistrez le numéro pour finaliser l’étape.",
        "saving": "Enregistrement..."
      },
      "mail": {
        "title": "Nouveau message",
        "to": "Destinataire",
        "subject": "Sujet",
        "body": "Message",
        "attachWaybill": "Joindre bordereau (PDF)",
        "attachRecap": "Joindre récap (PDF)",
        "note": "Aucun envoi automatique : vous pouvez modifier le message puis cliquer sur “Envoyer”.",
        "send": "Envoyer",
        "sending": "Envoi…"
      },
      "iban": {
        "title": "Coordonnées bancaires",
        "loading": "Chargement…",
        "error": "IBAN indisponible.",
        "masked": "IBAN (masqué) :",
        "holder": "Titulaire :",
        "caption": "L’IBAN complet est chiffré et n’est révélé que pour le paiement.",
        "reveal": "Révéler l’IBAN",
        "noData": "Aucune donnée IBAN pour cet utilisateur.",
        "revealError": "Révélation impossible."
      },
      "reveal": {
        "title": "IBAN révélé",
        "copy": "Copier",
        "warning": "Ne partagez cet IBAN que pour exécuter le paiement."
      },
      "common": {
        "openInTab": "Ouvrir dans un onglet",
        "close": "Fermer",
        "later": "Plus tard",
        "save": "Enregistrer",
        "unavailable": "Indisponible."
      },
      "errors": {
        "load": "Impossible de charger les transactions.",
        "update": "Mise à jour impossible.",
        "saveTracking": "Enregistrement impossible.",
        "uploadWaybill": "Upload du bordereau impossible.",
        "validateControl": "Impossible de valider le contrôle.",
        "sendEmail": "Échec de l’envoi de l’e-mail."
      }
    }
  },
  "en": {
    "transactions": {
      "title": "Transactions",
      "loading": "Loading…",
      "empty": "No transactions.",
      "labels": {
        "pcs": "pcs",
        "tracking": "Tracking:",
        "received": "Received"
      },
      "search": {
        "placeholder": "Search: id (8), email, ref…"
      },
      "filters": {
        "all": "All",
        "ongoing": "In progress",
        "completed": "Completed",
        "waybill": "Etichetta di spedizione",
        "reception": "Ricezione",
        "control": "Control",
        "pdf": "PDF",
        "paid": "Paid"
      },
      "steps": {
        "title": "Steps",
        "waybill": "Etichetta di spedizione",
        "reception": "Ricezione",
        "control": "Control",
        "pdf": "PDF",
        "paid": "Paid"
      },
      "actions": {
        "title": "Actions",
        "refresh": "Refresh",
        "control": "Control",
        "upload": "Upload",
        "uploading": "Uploading…",
        "waybill": "Etichetta di spedizione",
        "tracking": "Tracking",
        "pdf": "PDF",
        "detail": "Details",
        "iban": "IBAN",
        "uploadTooltip": "Upload (PDF)",
        "ibanTooltip": "View IBAN (masked) / Reveal for payment",
        "sendEmail": "Send email",
        "sendWaybillEmail": "Send waybill",
        "sendRecapEmail": "Send recap",
        "copyEmail": "Copy email"
      },
      "pdf": {
        "verif": {
          "title": "Preview — QC PDF",
          "loading": "Loading PDF…",
          "error": "PDF not found.",
          "empty": "PDF unavailable."
        },
        "waybill": {
          "title": "Preview — Waybill",
          "loading": "Loading waybill…",
          "error": "Waybill not found.",
          "empty": "No waybill."
        }
      },
      "setup": {
        "title": "Waybill uploaded — Enter parcel number",
        "refTitle": "Parcel reference",
        "help": "Enter the tracking number (Colissimo, Chronopost, etc.). It will be visible in the summary and to the customer.",
        "inputLabel": "Parcel number",
        "inputPlaceholder": "e.g. 6A12345678901",
        "alert": "Waybill stored. Save the number to finalize.",
        "saving": "Saving..."
      },
      "mail": {
        "title": "New message",
        "to": "Recipient",
        "subject": "Subject",
        "body": "Message",
        "attachWaybill": "Attach waybill (PDF)",
        "attachRecap": "Attach recap (PDF)",
        "note": "No automatic sending: you can edit the message and then click “Send”.",
        "send": "Send",
        "sending": "Sending…"
      },
      "iban": {
        "title": "Bank details",
        "loading": "Loading…",
        "error": "IBAN unavailable.",
        "masked": "IBAN (masked):",
        "holder": "Account holder:",
        "caption": "The full IBAN is encrypted and only revealed for payment.",
        "reveal": "Reveal IBAN",
        "noData": "No IBAN data for this user.",
        "revealError": "Reveal failed."
      },
      "reveal": {
        "title": "IBAN revealed",
        "copy": "Copy",
        "warning": "Share this IBAN only to execute the payment."
      },
      "common": {
        "openInTab": "Open in new tab",
        "close": "Close",
        "later": "Later",
        "save": "Save",
        "unavailable": "Unavailable."
      },
      "errors": {
        "load": "Could not load transactions.",
        "update": "Update failed.",
        "saveTracking": "Could not save.",
        "uploadWaybill": "Waybill upload failed.",
        "validateControl": "Could not validate QC.",
        "sendEmail": "Email sending failed."
      }
    }
  },
  "pl": {
    "transactions": {
      "title": "Transakcje",
      "loading": "Ładowanie…",
      "empty": "Brak transakcji.",
      "labels": {
        "pcs": "szt.",
        "tracking": "Śledzenie:",
        "received": "Odebrano"
      },
      "search": {
        "placeholder": "Szukaj: id (8), email, ref…"
      },
      "filters": {
        "all": "Wszystkie",
        "ongoing": "W toku",
        "completed": "Zakończone",
        "waybill": "List przewozowy",
        "reception": "Odbiór",
        "control": "Kontrola",
        "pdf": "PDF",
        "paid": "Opłacone"
      },
      "steps": {
        "title": "Etapy",
        "waybill": "List przewozowy",
        "reception": "Odbiór",
        "control": "Kontrola",
        "pdf": "PDF",
        "paid": "Opłacone"
      },
      "actions": {
        "title": "Akcje",
        "refresh": "Odśwież",
        "control": "Kontrola",
        "upload": "Wyślij",
        "uploading": "Wysyłanie…",
        "waybill": "List przewozowy",
        "tracking": "Śledzenie",
        "pdf": "PDF",
        "detail": "Szczegóły",
        "iban": "IBAN",
        "uploadTooltip": "Wyślij (PDF)",
        "ibanTooltip": "Zobacz IBAN (ukryty) / Ujawnij do płatności",
        "sendEmail": "Wyślij e-mail",
        "sendWaybillEmail": "Wyślij list przew.",
        "sendRecapEmail": "Wyślij podsum.",
        "copyEmail": "Kopiuj e-mail"
      },
      "pdf": {
        "verif": {
          "title": "Podgląd — PDF kontroli",
          "loading": "Ładowanie PDF…",
          "error": "PDF nie znaleziony.",
          "empty": "PDF niedostępny."
        },
        "waybill": {
          "title": "Podgląd — List przewozowy",
          "loading": "Ładowanie listu…",
          "error": "List przewozowy nie znaleziony.",
          "empty": "Brak listu przewozowego."
        }
      },
      "setup": {
        "title": "List przesłany — Wpisz numer paczki",
        "refTitle": "Referencja paczki",
        "help": "Podaj numer śledzenia (Colissimo, Chronopost itd.). Będzie widoczny w podsumowaniu i u klienta.",
        "inputLabel": "Numer paczki",
        "inputPlaceholder": "np. 6A12345678901",
        "alert": "List przewozowy zapisany. Zapisz numer, aby zakończyć etap.",
        "saving": "Zapisywanie..."
      },
      "mail": {
        "title": "Nowa wiadomość",
        "to": "Odbiorca",
        "subject": "Temat",
        "body": "Treść",
        "attachWaybill": "Dołącz list przewozowy (PDF)",
        "attachRecap": "Dołącz podsumowanie (PDF)",
        "note": "Brak automatycznej wysyłki: możesz edytować wiadomość i kliknąć „Wyślij”.",
        "send": "Wyślij",
        "sending": "Wysyłanie…"
      },
      "iban": {
        "title": "Dane bankowe",
        "loading": "Ładowanie…",
        "error": "IBAN niedostępny.",
        "masked": "IBAN (ukryty):",
        "holder": "Właściciel konta:",
        "caption": "Pełny IBAN jest szyfrowany i ujawniany tylko do płatności.",
        "reveal": "Ujawnij IBAN",
        "noData": "Brak danych IBAN dla tego użytkownika.",
        "revealError": "Nie udało się ujawnić."
      },
      "reveal": {
        "title": "IBAN ujawniony",
        "copy": "Kopiuj",
        "warning": "Udostępniaj ten IBAN wyłącznie w celu dokonania płatności."
      },
      "common": {
        "openInTab": "Otwórz w nowej karcie",
        "close": "Zamknij",
        "later": "Później",
        "save": "Zapisz",
        "unavailable": "Niedostępne."
      },
      "errors": {
        "load": "Nie udało się wczytać transakcji.",
        "update": "Aktualizacja nieudana.",
        "saveTracking": "Nie udało się zapisać.",
        "uploadWaybill": "Nie udało się wysłać listu przewozowego.",
        "validateControl": "Nie udało się zatwierdzić kontroli.",
        "sendEmail": "Nie udało się wysłać e-maila."
      }
    }
  },
  "es": {
    "transactions": {
      "title": "Transacciones",
      "loading": "Cargando…",
      "empty": "Ninguna transacción.",
      "labels": {
        "pcs": "uds",
        "tracking": "Seguimiento:",
        "received": "Recibido"
      },
      "search": {
        "placeholder": "Buscar: id (8), email, ref…"
      },
      "filters": {
        "all": "Todas",
        "ongoing": "En curso",
        "completed": "Terminadas",
        "waybill": "Etiqueta",
        "reception": "Recepción",
        "control": "Control",
        "pdf": "PDF",
        "paid": "Pagado"
      },
      "steps": {
        "title": "Etapas",
        "waybill": "Etiqueta",
        "reception": "Recepción",
        "control": "Control",
        "pdf": "PDF",
        "paid": "Pagado"
      },
      "actions": {
        "title": "Acciones",
        "refresh": "Actualizar",
        "control": "Control",
        "upload": "Subir",
        "uploading": "Subiendo…",
        "waybill": "Etiqueta",
        "tracking": "Seguimiento",
        "pdf": "PDF",
        "detail": "Detalles",
        "iban": "IBAN",
        "uploadTooltip": "Subir (PDF)",
        "ibanTooltip": "Ver IBAN (oculto) / Mostrar para pago",
        "sendEmail": "Enviar correo",
        "sendWaybillEmail": "Enviar etiqueta",
        "sendRecapEmail": "Enviar resumen",
        "copyEmail": "Copiar correo"
      },
      "pdf": {
        "verif": {
          "title": "Vista previa — PDF de control",
          "loading": "Cargando PDF…",
          "error": "PDF no encontrado.",
          "empty": "PDF no disponible."
        },
        "waybill": {
          "title": "Vista previa — Etiqueta",
          "loading": "Cargando etiqueta…",
          "error": "Etiqueta no encontrada.",
          "empty": "Sin etiqueta."
        }
      },
      "setup": {
        "title": "Etiqueta subida — Introducir número de paquete",
        "refTitle": "Referencia del paquete",
        "help": "Indique el número de seguimiento (Colissimo, Chronopost, etc.). Será visible en el resumen y para el cliente.",
        "inputLabel": "Número de paquete",
        "inputPlaceholder": "ej. 6A12345678901",
        "alert": "La etiqueta se ha guardado. Guarda el número para finalizar.",
        "saving": "Guardando..."
      },
      "mail": {
        "title": "Nuevo mensaje",
        "to": "Destinatario",
        "subject": "Asunto",
        "body": "Mensaje",
        "attachWaybill": "Adjuntar etiqueta (PDF)",
        "attachRecap": "Adjuntar resumen (PDF)",
        "note": "No hay envío automático: puedes editar el mensaje y luego hacer clic en “Enviar”.",
        "send": "Enviar",
        "sending": "Enviando…"
      },
      "iban": {
        "title": "Datos bancarios",
        "loading": "Cargando…",
        "error": "IBAN no disponible.",
        "masked": "IBAN (oculto):",
        "holder": "Titular:",
        "caption": "El IBAN completo está cifrado y solo se revela para el pago.",
        "reveal": "Mostrar IBAN",
        "noData": "No hay datos IBAN para este usuario.",
        "revealError": "No se pudo mostrar."
      },
      "reveal": {
        "title": "IBAN revelado",
        "copy": "Copiar",
        "warning": "Comparte este IBAN solo para ejecutar el pago."
      },
      "common": {
        "openInTab": "Abrir en nueva pestaña",
        "close": "Cerrar",
        "later": "Más tarde",
        "save": "Guardar",
        "unavailable": "No disponible."
      },
      "errors": {
        "load": "No se pudieron cargar las transacciones.",
        "update": "Actualización imposible.",
        "saveTracking": "No se pudo guardar.",
        "uploadWaybill": "No se pudo subir la etiqueta.",
        "validateControl": "No se pudo validar el control.",
        "sendEmail": "Error al enviar el correo."
      }
    }
  },
  "it": {
    "transactions": {
      "title": "Transazioni",
      "loading": "Caricamento...",
      "empty": "Niente transazioni.",
      "labels": {
        "pcs": "pc",
        "tracking": "Tracciamento:",
        "received": "Ricevuto"
      },
      "search": {
        "placeholder": "Ricerca: id (8), email, ref..."
      },
      "filters": {
        "all": "Tutti",
        "ongoing": "In corso",
        "completed": "Completato",
        "waybill": "Waybill",
        "reception": "Reception",
        "control": "Controllo",
        "pdf": "PDF",
        "paid": "Pagato"
      },
      "steps": {
        "title": "Passi",
        "waybill": "Waybill",
        "reception": "Reception",
        "control": "Controllo",
        "pdf": "PDF",
        "paid": "Pagato"
      },
      "actions": {
        "title": "Azioni",
        "refresh": "Rifiuti",
        "control": "Controllo",
        "upload": "Caricamento",
        "uploading": "Caricamento...",
        "waybill": "Waybill",
        "tracking": "Monitoraggio",
        "pdf": "PDF",
        "detail": "Dettagli",
        "iban": "IBAN",
        "uploadTooltip": "Caricamento (PDF)",
        "ibanTooltip": "IBAN (mascherato) / Rivelazione per il pagamento",
        "sendEmail": "Invia email",
        "sendWaybillEmail": "Invia la tua lettera",
        "sendRecapEmail": "Invia recap",
        "copyEmail": "Copia e-mail"
      },
      "pdf": {
        "verif": {
          "title": "Anteprima - QC PDF",
          "loading": "Caricamento PDF...",
          "error": "PDF non trovato.",
          "empty": "PDF non disponibile."
        },
        "waybill": {
          "title": "Anteprima — Waybill",
          "loading": "Caricamento in corso...",
          "error": "Waybill non trovato.",
          "empty": "Non c'e' niente di strano."
        }
      },
      "setup": {
        "title": "Waybill caricato — Inserisci il numero del pacchetto",
        "refTitle": "Riferimento del Parcel",
        "help": "Inserisci il numero di tracciamento (Colissimo, Chronopost, ecc.). Sarà visibile nel riassunto e al cliente.",
        "inputLabel": "Numero di pacchi",
        "inputPlaceholder": "es. 6A12345678901",
        "alert": "Waybill memorizzato. Salvare il numero per finalizzare.",
        "saving": "Salvare..."
      },
      "mail": {
        "title": "Nuovo messaggio",
        "to": "Recipiente",
        "subject": "Oggetto",
        "body": "Messaggio",
        "attachWaybill": "Attach waybill (PDF)",
        "attachRecap": "Riepilogo di allegati (PDF)",
        "note": "Nessun invio automatico: è possibile modificare il messaggio e quindi fare clic su \"Invia\".",
        "send": "Invia",
        "sending": "Invio..."
      },
      "iban": {
        "title": "Dettagli della banca",
        "loading": "Caricamento...",
        "error": "IBAN non disponibile.",
        "masked": "IBAN (mascherato):",
        "holder": "Titolare del conto:",
        "caption": "L'IBAN completo è crittografato e rivelato solo per il pagamento.",
        "reveal": "Rivelazione IBAN",
        "noData": "Nessun dato IBAN per questo utente.",
        "revealError": "Reveal ha fallito."
      },
      "reveal": {
        "title": "IBAN ha rivelato",
        "copy": "Copia",
        "warning": "Condividi questo IBAN solo per eseguire il pagamento."
      },
      "common": {
        "openInTab": "Aprire nella nuova scheda",
        "close": "Chiudi",
        "later": "Più tardi.",
        "save": "Salva",
        "unavailable": "Non disponibile."
      },
      "errors": {
        "load": "Non poteva caricare le transazioni.",
        "update": "Aggiornamento fallito.",
        "saveTracking": "Non potevo salvare.",
        "uploadWaybill": "Caricamento di Waybill fallito.",
        "validateControl": "Non poteva convalidare QC.",
        "sendEmail": "L'invio di email è fallito."
      }
    }
  },
  "de": {
    "transactions": {
      "title": "Transaktionen",
      "loading": "Beladung...",
      "empty": "Keine Transaktionen.",
      "labels": {
        "pcs": "pcs",
        "tracking": "Sendungsverfolgung:",
        "received": "Empfangen"
      },
      "search": {
        "placeholder": "Suche: ID (8), E-Mail, Ref..."
      },
      "filters": {
        "all": "alle",
        "ongoing": "Im Gange",
        "completed": "Abgeschlossen",
        "waybill": "Frachtbrief",
        "reception": "Empfang",
        "control": "Kontrolle",
        "pdf": "PDF",
        "paid": "Bezahlt"
      },
      "steps": {
        "title": "Stufen",
        "waybill": "Frachtbrief",
        "reception": "Empfang",
        "control": "Kontrolle",
        "pdf": "PDF",
        "paid": "Bezahlt"
      },
      "actions": {
        "title": "Aktionen",
        "refresh": "Erfrischend",
        "control": "Kontrolle",
        "upload": "Hochladen",
        "uploading": "Hochladen...",
        "waybill": "Frachtbrief",
        "tracking": "Verfolgung",
        "pdf": "PDF",
        "detail": "Einzelheiten",
        "iban": "IBAN",
        "uploadTooltip": "Upload (PDF)",
        "ibanTooltip": "Ansicht IBAN (maskiert) / Reveal für die Zahlung",
        "sendEmail": "E-Mail senden",
        "sendWaybillEmail": "Versenden von Waybill",
        "sendRecapEmail": "Senden Sie Recap",
        "copyEmail": "E-Mail kopieren"
      },
      "pdf": {
        "verif": {
          "title": "Vorschau - QC PDF",
          "loading": "PDF laden...",
          "error": "PDF nicht gefunden.",
          "empty": "PDF nicht verfügbar."
        },
        "waybill": {
          "title": "Vorschau — Waybill",
          "loading": "Frachtbrief ...",
          "error": "Waybill nicht gefunden.",
          "empty": "Kein Waybill."
        }
      },
      "setup": {
        "title": "Hochgeladener Frachtbrief — Nummer des Pakets eintragen",
        "refTitle": "Referenzpaket",
        "help": "Geben Sie die Tracking-Nummer (Colissimo, Chronopost, etc.) ein. Es wird in der Zusammenfassung und für den Kunden sichtbar sein.",
        "inputLabel": "Paketnummer",
        "inputPlaceholder": "z. B. 6A12345678901",
        "alert": "Frachtbrief gelagert. Speichern Sie die Zahl zum Finalisieren.",
        "saving": "Rettung..."
      },
      "mail": {
        "title": "Neue Nachricht",
        "to": "Empfänger",
        "subject": "Thema",
        "body": "Nachricht",
        "attachWaybill": "Attach Waybill (PDF)",
        "attachRecap": "Attach recap (PDF)",
        "note": "Kein automatisches Senden: Sie können die Nachricht bearbeiten und dann auf \"Senden\" klicken.",
        "send": "Senden",
        "sending": "Senden..."
      },
      "iban": {
        "title": "Bankdaten",
        "loading": "Beladung...",
        "error": "IBAN nicht verfügbar.",
        "masked": "IBAN (maskiert):",
        "holder": "Kontoinhaber:",
        "caption": "Die vollständige IBAN wird verschlüsselt und nur zur Zahlung freigegeben.",
        "reveal": "IBAN-Enthüllung",
        "noData": "Keine IBAN-Daten für diesen Benutzer.",
        "revealError": "Reveal ist gescheitert."
      },
      "reveal": {
        "title": "IBAN enthüllt",
        "copy": "Kopie",
        "warning": "Teilen Sie diese IBAN nur, um die Zahlung auszuführen."
      },
      "common": {
        "openInTab": "Öffnen im neuen Tab",
        "close": "Schließen",
        "later": "Später",
        "save": "Sparen",
        "unavailable": "Nicht verfügbar."
      },
      "errors": {
        "load": "Transaktionen konnten nicht geladen werden.",
        "update": "Update fehlgeschlagen.",
        "saveTracking": "Konnte nicht retten.",
        "uploadWaybill": "Waybill Upload ist fehlgeschlagen.",
        "validateControl": "QC konnte nicht validiert werden.",
        "sendEmail": "E-Mail-Versand fehlgeschlagen."
      }
    }
  },
  "pt": {
    "transactions": {
      "title": "Operações",
      "loading": "Carregando...",
      "empty": "Sem transacções.",
      "labels": {
        "pcs": "pcs",
        "tracking": "Rastreamento:",
        "received": "Recebido"
      },
      "search": {
        "placeholder": "Procurar: id (8), e- mail, ref..."
      },
      "filters": {
        "all": "Tudo",
        "ongoing": "Em curso",
        "completed": "Concluído",
        "waybill": "Etichetta di spedizione",
        "reception": "Riceziona",
        "control": "Controlo",
        "pdf": "PDF",
        "paid": "Pago"
      },
      "steps": {
        "title": "Passos",
        "waybill": "Etichetta di spedizione",
        "reception": "Riceziona",
        "control": "Controlo",
        "pdf": "PDF",
        "paid": "Pago"
      },
      "actions": {
        "title": "Acções",
        "refresh": "Actualizar",
        "control": "Controlo",
        "upload": "Enviar",
        "uploading": "Enviando...",
        "waybill": "Etichetta di spedizione",
        "tracking": "Rastreamento",
        "pdf": "PDF",
        "detail": "Detalhes",
        "iban": "IBAN",
        "uploadTooltip": "Enviar (PDF)",
        "ibanTooltip": "Ver IBAN (mascarado) / Revelar para pagamento",
        "sendEmail": "Enviar e- mail",
        "sendWaybillEmail": "Enviar o waybill",
        "sendRecapEmail": "Enviar recapitulação",
        "copyEmail": "Copiar e- mail"
      },
      "pdf": {
        "verif": {
          "title": "Visualização — QC PDF",
          "loading": "Carregando PDF...",
          "error": "PDF não encontrado.",
          "empty": "PDF indisponível."
        },
        "waybill": {
          "title": "Antevisão — Waybill",
          "loading": "A carregar o waybill...",
          "error": "O Waybill não foi encontrado.",
          "empty": "Nem pensar."
        }
      },
      "setup": {
        "title": "Waybill carregado — Digite o número do pacote",
        "refTitle": "Referência do pacote",
        "help": "Digite o número de rastreamento (Colissimo, Chronopost, etc.). Será visível no resumo e para o cliente.",
        "inputLabel": "Número de parcel",
        "inputPlaceholder": "Por exemplo, 6A12345678901",
        "alert": "O Waybill está guardado. Salve o número para finalizar.",
        "saving": "A gravar..."
      },
      "mail": {
        "title": "Nova mensagem",
        "to": "Destinatário",
        "subject": "Assunto",
        "body": "Mensagem",
        "attachWaybill": "Anexar o waybill (PDF)",
        "attachRecap": "Anexar recap (PDF)",
        "note": "Sem envio automático: você pode editar a mensagem e clicar em \"Enviar\".",
        "send": "Enviar",
        "sending": "Enviando..."
      },
      "iban": {
        "title": "Dados bancários",
        "loading": "Carregando...",
        "error": "IBAN indisponível.",
        "masked": "IBAN (mascarado):",
        "holder": "Titular da conta:",
        "caption": "O IBAN completo é criptografado e só é revelado para pagamento.",
        "reveal": "Revelar IBAN",
        "noData": "Não existem dados IBAN para este utilizador.",
        "revealError": "A revelação falhou."
      },
      "reveal": {
        "title": "IBAN revelado",
        "copy": "Copiar",
        "warning": "Compartilhe este IBAN apenas para executar o pagamento."
      },
      "common": {
        "openInTab": "Abrir numa página nova",
        "close": "Fechar",
        "later": "Mais tarde.",
        "save": "Gravar",
        "unavailable": "Indisponível."
      },
      "errors": {
        "load": "Não foi possível carregar transações.",
        "update": "A actualização falhou.",
        "saveTracking": "Não foi possível salvar.",
        "uploadWaybill": "O upload do Waybill falhou.",
        "validateControl": "Não foi possível validar o QC.",
        "sendEmail": "O envio de e- mail falhou."
      }
    }
  },
  "cs": {
    "transactions": {
      "title": "Transakce",
      "loading": "Nabíjím...",
      "empty": "Žádné transakce.",
      "labels": {
        "pcs": "ks",
        "tracking": "Sledování:",
        "received": "Přijato"
      },
      "search": {
        "placeholder": "Vyhledávání: id (8), e-mail, ref..."
      },
      "filters": {
        "all": "Všechny",
        "ongoing": "Probíhá",
        "completed": "Dokončeno",
        "waybill": "Etichetta di spedizione",
        "reception": "Ricezione",
        "control": "Kontrola",
        "pdf": "PDF",
        "paid": "Placené"
      },
      "steps": {
        "title": "Kroky",
        "waybill": "Etichetta di spedizione",
        "reception": "Ricezione",
        "control": "Kontrola",
        "pdf": "PDF",
        "paid": "Placené"
      },
      "actions": {
        "title": "Akce",
        "refresh": "Obnovit",
        "control": "Kontrola",
        "upload": "Nahrát",
        "uploading": "Nahrávám...",
        "waybill": "Etichetta di spedizione",
        "tracking": "Sledování",
        "pdf": "PDF",
        "detail": "Podrobnosti",
        "iban": "IBAN",
        "uploadTooltip": "Nahrát (PDF)",
        "ibanTooltip": "Zobrazit IBAN (maskovaný) / Odhalení platby",
        "sendEmail": "Odeslat email",
        "sendWaybillEmail": "Poslat nákladní list",
        "sendRecapEmail": "Odeslat rekapitulaci",
        "copyEmail": "Kopírovat email"
      },
      "pdf": {
        "verif": {
          "title": "Náhled - QC PDF",
          "loading": "Načítám PDF...",
          "error": "PDF nenalezeno.",
          "empty": "PDF není k dispozici."
        },
        "waybill": {
          "title": "Náhled - Waybill",
          "loading": "Načítám nákladní list...",
          "error": "Waybill nenalezen.",
          "empty": "Žádný nákladní list."
        }
      },
      "setup": {
        "title": "Nahráno Waybill - Zadejte číslo balíku",
        "refTitle": "Popis zboží",
        "help": "Zadejte sledovací číslo (Colissimo, Chronopost, atd.). Bude vidět v souhrnu a zákazníkovi.",
        "inputLabel": "Číslo zásilky",
        "inputPlaceholder": "např. 6A12345678901",
        "alert": "Waybill uložen. Uložit číslo k dokončení.",
        "saving": "Zachraňuji..."
      },
      "mail": {
        "title": "Nová zpráva",
        "to": "Příjemce",
        "subject": "Předmět",
        "body": "Zpráva",
        "attachWaybill": "Přiložit nákladní list (PDF)",
        "attachRecap": "Připojit rekapitulaci (PDF)",
        "note": "Žádné automatické odesílání: zprávu můžete upravit a pak kliknout na \"Odeslat\".",
        "send": "Odeslat",
        "sending": "Posílám..."
      },
      "iban": {
        "title": "Bankovní údaje",
        "loading": "Nabíjím...",
        "error": "IBAN není k dispozici.",
        "masked": "IBAN (maskovaný):",
        "holder": "Držitel účtu:",
        "caption": "Kompletní IBAN je zašifrovaný a odhalený pouze pro platbu.",
        "reveal": "Odhalte IBAN",
        "noData": "Žádné IBAN data pro tohoto uživatele.",
        "revealError": "Odhalení selhalo."
      },
      "reveal": {
        "title": "IBAN odhalil",
        "copy": "Kopírovat",
        "warning": "Sdílejte tuto IBAN pouze pro provedení platby."
      },
      "common": {
        "openInTab": "Otevřít v nové kartě",
        "close": "Zavřít",
        "later": "Později.",
        "save": "Uložit",
        "unavailable": "Nemožné."
      },
      "errors": {
        "load": "Nelze načíst transakce.",
        "update": "Aktualizace selhala.",
        "saveTracking": "Nelze zachránit.",
        "uploadWaybill": "Nahrávání Waybillu selhalo.",
        "validateControl": "Nelze potvrdit QC.",
        "sendEmail": "Odeslání emailu selhalo."
      }
    }
  },
  "nl": {
    "transactions": {
      "title": "Transacties",
      "loading": "Laden...",
      "empty": "Geen transacties.",
      "labels": {
        "pcs": "stuks",
        "tracking": "Tracking:",
        "received": "Ontvangen"
      },
      "search": {
        "placeholder": "Zoeken: id (8), e-mail, ref..."
      },
      "filters": {
        "all": "Alles",
        "ongoing": "Aan de gang",
        "completed": "Voltooid",
        "waybill": "Etichetta di spedizione",
        "reception": "Rijst",
        "control": "Controle",
        "pdf": "PDF",
        "paid": "Betaald"
      },
      "steps": {
        "title": "Stappen",
        "waybill": "Etichetta di spedizione",
        "reception": "Rijst",
        "control": "Controle",
        "pdf": "PDF",
        "paid": "Betaald"
      },
      "actions": {
        "title": "Acties",
        "refresh": "Verversen",
        "control": "Controle",
        "upload": "Uploaden",
        "uploading": "Uploaden...",
        "waybill": "Etichetta di spedizione",
        "tracking": "Tracking",
        "pdf": "PDF",
        "detail": "Gegevens",
        "iban": "IBAN",
        "uploadTooltip": "Uploaden (PDF)",
        "ibanTooltip": "Beeld IBAN (gemaskerd) / Onthullen voor betaling",
        "sendEmail": "E-mail versturen",
        "sendWaybillEmail": "Waynill verzenden",
        "sendRecapEmail": "Samenvatting versturen",
        "copyEmail": "E-mail kopiëren"
      },
      "pdf": {
        "verif": {
          "title": "Voorbeeld QC PDF",
          "loading": "PDF wordt geladen...",
          "error": "PDF niet gevonden.",
          "empty": "PDF niet beschikbaar."
        },
        "waybill": {
          "title": "Voorbeeld",
          "loading": "Waybill wordt geladen...",
          "error": "Waybill niet gevonden.",
          "empty": "Geen waybill."
        }
      },
      "setup": {
        "title": "Waybill geüpload",
        "refTitle": "Rubrieknummer",
        "help": "Voer het traceernummer in (Colissimo, Chronopost, enz.). Het zal zichtbaar zijn in de samenvatting en voor de klant.",
        "inputLabel": "Pakketnummer",
        "inputPlaceholder": "bv. 6A12345678901",
        "alert": "Waybill opgeslagen. Bewaar het nummer om af te ronden.",
        "saving": "Opslaan..."
      },
      "mail": {
        "title": "Nieuw bericht",
        "to": "Onderneming",
        "subject": "Onderwerp",
        "body": "Bericht",
        "attachWaybill": "Bijvoegen waybill (PDF)",
        "attachRecap": "Recap (PDF) bijvoegen",
        "note": "Geen automatisch verzenden: u kunt het bericht bewerken en klik vervolgens op Verzenden.",
        "send": "Verzenden",
        "sending": "Verzenden..."
      },
      "iban": {
        "title": "Bankgegevens",
        "loading": "Laden...",
        "error": "IBAN is niet beschikbaar.",
        "masked": "IBAN (gemaskerd):",
        "holder": "Rekeninghouder:",
        "caption": "Het volledige IBAN is gecodeerd en alleen geopenbaard voor betaling.",
        "reveal": "Openen IBAN",
        "noData": "Geen IBAN-gegevens voor deze gebruiker.",
        "revealError": "Onthullen mislukt."
      },
      "reveal": {
        "title": "IBAN onthuld",
        "copy": "Kopiëren",
        "warning": "Deel dit IBAN alleen om de betaling uit te voeren."
      },
      "common": {
        "openInTab": "In nieuw tabblad openen",
        "close": "Sluiten",
        "later": "Later",
        "save": "Opslaan",
        "unavailable": "Niet beschikbaar."
      },
      "errors": {
        "load": "Kon transacties niet laden.",
        "update": "Update mislukt.",
        "saveTracking": "Kon niet opslaan.",
        "uploadWaybill": "Waybill upload mislukt.",
        "validateControl": "Kon QC niet valideren.",
        "sendEmail": "E-mail verzenden is mislukt."
      }
    }
  }
};

export default transactionsI18n;
